import { orderStatuses, orderTypes, perms } from '../names';

//+07:00 => 7 | -04:00 => -4
function convertUTC2Number(UTC) {
    return Number(UTC.split(':')[0]);
}

export const UTCToString = (UTC) =>
    `${UTC < 0 ? '-' : '+'}${String(Math.abs(UTC)).padStart(2, '0')}:00`;

const phoneMask = /^7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}$/;

export function getMainUTCMonth(mainUTCStr, timestamp = Date.now()) {
    const mainUTC = convertUTC2Number(mainUTCStr);
    const clientUTC = -new Date().getTimezoneOffset() / 60;
    const UTC_offset = mainUTC - clientUTC;
    const date = new Date(timestamp + 1000 * 3600 * UTC_offset);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${yyyy}-${mm}`;
}
export function getStartOfMonthTimestamp(now = new Date(), mainUTCStr) {
    const mainUTC = convertUTC2Number(mainUTCStr);
    const clientUTC = -new Date().getTimezoneOffset() / 60;
    const UTC_offset = mainUTC - clientUTC;
    const localNow = new Date(+now + UTC_offset * 1000 * 3600);
    const MM = (localNow.getMonth() + 1).toString().padStart(2, '0');
    const YYYY = localNow.getFullYear();
    return +new Date(`${YYYY}-${MM}-01T00:00:00${mainUTCStr}`);
}

export function getLocalUTCDate(
    localUTC,
    timestamp = Date.now(),
    forInput = false,
) {
    const clientUTC = -new Date().getTimezoneOffset() / 60;
    const UTC_offset = localUTC - clientUTC;
    const date = new Date(timestamp + 1000 * 3600 * UTC_offset);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return forInput ? `${yyyy}-${mm}-${dd}` : `${dd}.${mm}.${yyyy}`;
}

//yyyy-mm-ddThh:mm
export function getLocalUTCDateTimestamp(localUTC, dateStr) {
    const strUTC = UTCToString(localUTC);
    return +new Date(`${dateStr}${strUTC}`);
}
export function getFullDateStringByStamp(localUTC, timestamp) {
    const clientUTC = -new Date().getTimezoneOffset() / 60;
    const UTC_offset = localUTC - clientUTC;
    const date = new Date(timestamp + 1000 * 3600 * UTC_offset);
    const min = String(date.getMinutes()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

export function getLocalUTCTime(localUTC, date, toStr = false) {
    const clientUTC = -new Date().getTimezoneOffset() / 60;
    const UTC_offset = localUTC - clientUTC;
    const { min, max } = date;
    const date1 = new Date(min + 1000 * 3600 * UTC_offset);
    const hh1 = String(date1.getHours()).padStart(2, '0');
    const mm1 = String(date1.getMinutes()).padStart(2, '0');
    if (min === max) {
        const result = `${hh1}:${mm1}`;
        return toStr ? result : { min: result, max: result };
    }
    const date2 = new Date(max + 1000 * 3600 * UTC_offset);
    const hh2 = String(date2.getHours()).padStart(2, '0');
    const mm2 = String(date2.getMinutes()).padStart(2, '0');
    const result = [`${hh1}:${mm1}`, `${hh2}:${mm2}`];
    return toStr ? `${hh1}:${mm1}-${hh2}:${mm2}` : { min: result[0], max: result[1] };
}

export function getNextHour() {
    const date = new Date();
    date.setHours(date.getHours() + 1, 0, 0);
    return date.toLocaleTimeString().slice(0, 5);
}

export function formatTimestampToDayDate(timestamp) {
    const now = new Date();
    const date = new Date(timestamp);
  
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  
    if (date >= today) {
      return `сегодня в ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else if (date >= yesterday) {
      return `вчера в ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else {
      if (date.getFullYear() !== now.getFullYear()) {
        return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()} в ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      } else {
        return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')} в ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      }
    }
}

export function formatAddress(address) {
    const { village, street, apartmentNumber, additional } = address;
    if (!village && !street && !apartmentNumber && !additional) return null;
    const str1 = village ? village + (street || apartmentNumber ? ', ' : ' ') : '';
    const str2 = street ? street + (apartmentNumber ? ', ' : ' ') : '';
    const str3 = apartmentNumber ? `кв: ${apartmentNumber} ` : '';
    const str4 = additional ? `(дмф: ${additional})` : '';
    return `${str1}${str2}${str3}${str4}`;
}

export function getOrderStatusType(order) {
    const name = order.orderStatus.name;

    if (name === orderStatuses.AWAIT_ACCEPTANCE) {
        return 'not-accepted';
    }
    const processStatuses = [
        orderStatuses.ACCEPTED,
        orderStatuses.IN_WAY,
        orderStatuses.WORKING,
        orderStatuses.FINISHING,
    ];
    if (processStatuses.some((statusName) => statusName === name)) {
        return 'process';
    }
    if (name === orderStatuses.CANCEL) {
        return 'cancel';
    }
    if (name === orderStatuses.MODERN) {
        return 'modern';
    }
    if (name === orderStatuses.DONE) {
        if (order.orderType.name === orderTypes.WARRANTY) {
            return 'warranty';
        }
        return order.totalAmount === 0 ? 'reject' : 'done';
    }
    return '';
}

export function getContrastingColor(hexColor) {
    // Преобразуем шестнадцатеричный цвет в RGB-значения
    let r = parseInt(hexColor.substring(1, 3), 16);
    let g = parseInt(hexColor.substring(3, 5), 16);
    let b = parseInt(hexColor.substring(5, 7), 16);

    // Рассчитываем яркость цвета
    let brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Возвращаем белый цвет для темных цветов и черный цвет для светлых цветов
    return brightness > 128 ? '#000000' : '#FFFFFF';
}
export function compareObjects(test, template) {

    try {
        const testKeys = Object.keys(test);
        const templateKeys = Object.keys(template);

        // Проверяем количество ключей
        if (testKeys.length !== templateKeys.length) {
            return false;
        }

        // Проверяем наличие всех ключей
        for (const key of testKeys) {
            if (!templateKeys.includes(key)) {
                return false;
            }
        }

        // Проверяем типы значений
        for (const key of testKeys) {
            if (typeof test[key] !== typeof template[key]) {
                return false;
            }
        }

        // Проверяем типы значений во вложенных объектах

        for (const key in test) {
            if (typeof test[key] === 'object' && test[key] !== null) {
                const isValid = compareObjects(test[key], template[key]);
                if (!isValid) {
                    return false;
                }
            }
        }

        return true;
    } catch(e) {
        return false;
    }
}

export function checkSavedOrderObject(order, settings) {
    const enumKeys = [['advertType', 'advertTypes'], ['city', 'orderCities'], ['orderType', 'orderTypes'], ['profileType', 'orderProfiles']];
    for (let i = 0; i < enumKeys.length; i++) {
        const templ = settings[enumKeys[i][1]];
        const cur = order[enumKeys[i][0]];
        if (!templ.some((e) => e._id === cur)) {
            return false;
        }
    }
    return true
}
export function isValidOrderFilters(filter, settings, userList) {
    
    const enumKeys = [
        ["advertType", "advertTypes"],
        ["orderType", "orderTypes"],
        ["orderStatus", "orderStatuses"],
    ]
    const allKeys = ['advertType', 'orderType', 'isProfile', 'orderStatus', 'worker', 'creator', 'date', 'clearAmount', 'completionDate'];
    try {
        if (settings.orderCities.length > 1) {
            if (!filter.some((ft) => ft?.key === 'city')) return false;
            enumKeys.push(["city", "orderCities"])
            allKeys.push("city");
        }
        if (settings.orderProfiles.length > 1) {
            if (!filter.some((ft) => ft?.key === 'profileType')) return false;
            enumKeys.push(["profileType", "orderProfiles"])
            allKeys.push("profileType")
        }
        if (allKeys.length !== filter.length) return false;
        for (let i = 0; i < filter.length; i++) {
            const has = allKeys.find((k) => k === filter[i].key);
            if (!has) {
                return false;
            }
        }
        for (let i = 0; i < enumKeys.length; i++) {
            const templ = settings[enumKeys[i][1]];
            const cur = filter.find((f) => f.key === enumKeys[i][0]).list;
            const str1 = JSON.stringify([...templ].sort((a,b) => a._id.localeCompare(b._id)));
            const str2 = JSON.stringify([...cur].sort((a,b) => a._id.localeCompare(b._id)));
            if (str1 !== str2) {
                return false;
            }
        }
        const templWorkerFilter = settings.orderUsers.filter(u => userList.some(u2 => u2._id === u && !u2.deleted && u2.profiles.length));
        const curWorkerFilter = filter.find((f) => f.key === 'worker').list;
        const str1 = JSON.stringify([...templWorkerFilter, 'null'].sort((a,b) => a.localeCompare(b)));
        const str2 = JSON.stringify([...curWorkerFilter].sort((a,b) => a.localeCompare(b)));
        if (str1 !== str2) {
            return false;
        }

        const templCreatorFilter = settings.orderUsers.filter(u => userList.some(u2 => u2._id === u && !u2.deleted && accessor.orders(u2)));
        const curCreatorFilter = filter.find((f) => f.key === 'creator').list;
        const str11 = JSON.stringify(templCreatorFilter.sort((a,b) => a.localeCompare(b)));
        const str22 = JSON.stringify([...curCreatorFilter].sort((a,b) => a.localeCompare(b)));
        if (str11 !== str22) {
            return false;
        }

        return true;
    } catch(_) {
        return false;
    }
}

export function definePermission(permObj, target) {
    //Если право не найдено (ошибка) - return null
    //Если найдено, то проверяем на список возможных энумов (users, cities, profiles)
    //возвращаем {flag, list: Array || null}
    function check(obj, target) {
        if (target in obj) {
            for (let key in obj[target]) {
                if (Array.isArray(obj[target][key])) {
                    return {
                        flag: obj[target].flag,
                        list: obj[target][key],
                    };
                }
            }
            return {
                flag: obj[target].flag,
                list: null,
            };
        } else {
            for (let prop in obj) {
                if (typeof obj[prop] === 'object') {
                    const result = check(obj[prop], target);
                    if (result !== null) {
                        return result;
                    }
                }
            }
        }
        return null;
    }
    const result = check(permObj, target);
    if (result === null) {
        throw new Error('Неизвестное свойство permission');
    }
    return result;
}

export function checkPermission(obj, target, prop, someEnum = false) {
    //list - список objectId доступных элементов, если нет доступа КО ВСЕМ (города, профили, пользователи)
    const { flag, list } = definePermission(obj, target);
    if (flag) {
        return true;
    }
    if (!list) {
        return flag;
    }
    //prop может быть как единственным (город), так и массивом (профили)
    if (Array.isArray(prop)) {
        return someEnum
            ? !!prop.some((el) => list.find((el2) => el.toString() === el2.toString()))
            : !!prop.every((el) => list.find((el2) => el.toString() === el2.toString()));
    }
    return !!list.find((el) => el.toString() === prop.toString());
}

function parseTimeString(str) {
    const time = str.split('-');

    let min = time[0];
    let max = time[1] || null;

    if (min.split(':').length === 1) {
        min = `${min}:00`;
    }
    if (!max) {
        return { minTime: min, maxTime: min };
    }
    if (max.split(':').length === 1) {
        max = `${max}:00`;
    }
    return { minTime: min, maxTime: max };
}
export function formatDateToMainUTC(date, time, UTC) {
    const strUTC = `${UTC < 0 ? '-' : '+'}${String(Math.abs(UTC)).padStart(2, '0')}:00`;
    const { minTime, maxTime } = parseTimeString(time);
    const datetime = +new Date(`${date}T${minTime}${strUTC}`);
    if (minTime === maxTime) {
        return { min: datetime, max: datetime };
    }
    const datetime2 = +new Date(`${date}T${maxTime}${strUTC}`);
    return { min: datetime, max: datetime2 };
}

export const accessor = {
    thisOrderAccess(user, order) {
        const userAccess = order.worker
            ? checkPermission(user.role.permissions, perms.ALL_USER_ORDERS, order.worker._id)
            : true;

        const profileAccess = checkPermission(
            user.role.permissions,
            perms.ALL_PROFILE_ORDERS,
            order.profileType._id,
        );
        const cityAccess = checkPermission(
            user.role.permissions,
            perms.ALL_CITY_ORDERS,
            order.city._id,
        );
        return userAccess && profileAccess && cityAccess;
    },
    createOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_CREATE_ORDER).flag;
    },
    orders(user) {
        return definePermission(user.role.permissions, perms.HAS_ORDERS_ACCESS).flag;
    },
    office(user) {
        return definePermission(user.role.permissions, perms.HAS_OFFICE_ACCESS).flag;
    },
    assignOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_ASSIGN_ORDER).flag;
    },
    revokeOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_REVOKE_ORDER).flag;
    },
    resetOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_RESET_ORDER).flag;
    },
    editOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_EDIT_ORDER).flag;
    },
    editOrderCompleteData(user) {
        return definePermission(user.role.permissions, perms.CAN_EDIT_COMPLETE_DATA).flag;
    },
    deleteOrder(user) {
        return definePermission(user.role.permissions, perms.CAN_DELETE_ORDER).flag;
    },
    finishOrder(user) {
        return (
            definePermission(user.role.permissions, perms.CAN_CANCEL_ORDER).flag ||
            definePermission(user.role.permissions, perms.CAN_MODERN_ORDER).flag ||
            definePermission(user.role.permissions, perms.CAN_DONE_ORDER).flag
        );
    },
    orderHistory(user) {
        return definePermission(user.role.permissions, perms.CAN_SEE_ORDER_HISTORY).flag;
    },
    workOnOrders(user) {
        return definePermission(user.role.permissions, perms.CAN_WORK_ON_ORDERS).flag;
    },
    clientPhone(user) {
        return definePermission(user.role.permissions, perms.CAN_SEE_CLIENT_NUMBERS).flag;
    },
    handOver(user) {
        return definePermission(user.role.permissions, perms.CAN_HAND_OVER).flag;
    },
    revenues(user) {
        return definePermission(user.role.permissions, perms.HAS_REVENUES_ACCESS).flag;
    },
    expenses(user) {
        return definePermission(user.role.permissions, perms.HAS_EXPENSES_ACCESS).flag;
    },
    createExpenses(user) {
        return definePermission(user.role.permissions, perms.CAN_CREATE_EXPENSE).flag;
    },
    usersInteract(user) {
        return definePermission(user.role.permissions, perms.HAS_USERS_INTERACTION_ACCESS).flag;
    },
    createUser(user) {
        return definePermission(user.role.permissions, perms.CAN_CREATE_USER).flag;
    },
    advertAccess(user) {
        return definePermission(user.role.permissions, perms.HAS_ADVERT_ACCESS).flag;
    },
    promoterInteractAccess(user) {
        return definePermission(user.role.permissions, perms.HAS_PROMOTERS_INTERACT_ACCESS).flag;
    },
};

function validateTimeString(str) {
    const timePattern =
        /^(?:(?:([0-1]\d|2[0-3]):([0-5]\d))|([0-1]\d|2[0-3]))(?:(?:-)(?:(?:([0-1]\d|2[0-3]):([0-5]\d))|([0-1]\d|2[0-3])))?$/;
    if (str === '' || typeof str !== 'string') {
        return false;
    }
    return timePattern.test(str);
}

export function generateGridTemplateColumns(columnSizes, titles) {
    
    return titles.map((title) => columnSizes[title.key] || columnSizes.default).join(' ');
}

export const validateOrderFields = (order, titles) => {
    const unRequired = {
        worker: true,
        totalAmount: true,
        partsCost: true,
        completionDate: true,
        workerComment: true,
    };
    for (const key in order) {
        if (key === 'time') {
            if (!validateTimeString(order[key])) {
                return { isOkay: false, message: 'Время' };
            }
        } else if (key === 'address') {
            if (
                !order[key].village &&
                !order[key].street &&
                !order[key].apartmentNumber &&
                !order[key].additional
            ) {
                return { isOkay: false, message: 'Адрес' };
            }
        } else if (key === 'clientPhone') {
            if (!phoneMask.test(order[key])) {
                return { isOkay: false, message: 'Номер телефона' };
            }
        } else if (key === 'totalAmount' || key === 'partsCost') {
            
            if (isNaN(+order[key])) {
                return { isOkay: false, message: 'Общая и ЗПЧ должны быть числами' };
            }
        } else {
            
            if (!order[key] && typeof order[key] !== 'boolean' && !unRequired[key]) {
                const keyLabel = titles.find((k) => k.key === key).label;
                return { isOkay: false, message: keyLabel };
            }
        }
    }
    return { isOkay: true };
};

export const validateUserFields = (body) => {
    if (!body.telegramId) {
        return { isOkay: false, message: 'Логин пользователя' };
    }
    if (!body.password) {
        return { isOkay: false, message: 'Пароль пользователя' };
    }
    if (!body.fullname || body.fullname.split(' ').length !== 2) {
        return { isOkay: false, message: 'Полное имя' };
    }
    const phone = body.personalData.phoneNumber;
    if (phone && !phoneMask.test(phone)) {
        return { isOkay: false, message: 'Номер телефона' };
    }
    if (!body.city) {
        return { isOkay: false, message: 'Город пользователя' };
    }
    if (!body.role.name) {
        return { isOkay: false, message: 'Роль пользователя' };
    }

    return { isOkay: true };
}

export const validateCreatePromoter = (body) => {
    if (!body.telegramId) {
        return { isOkay: false, message: 'telegramId' };
    }
    if (!body.id && body.id !== 0) {
        return { isOkay: false, message: 'Идентификатор промоутера' };
    }
    if (!body.fullname || body.fullname.split(' ').length !== 2) {
        return { isOkay: false, message: 'Полное имя' };
    }
    if (!body.bet) {
        return { isOkay: false, message: 'Ставка' };
    }
    if (!phoneMask.test(body.phoneNumber)) {
        return { isOkay: false, message: 'Номер телефона' };
    }
    if (!body.age) {
        return { isOkay: false, message: 'Возраст промоутера' };
    }

    return { isOkay: true };
}
export const validateAssignRoute = (body) => {
    if (!body.flyers.length) {
        return { isOkay: false, message: 'Не выбрана ни одна листовка' };
    }
    if (!body.bet) {
        return { isOkay: false, message: 'Ставка за ящик' };
    }

    return { isOkay: true };
}


export function numberToEmoji(number) {
    const emojiDigits = ['0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣'];
    const digits = String(number)
        .split('')
        .map((digit) => emojiDigits[Number(digit)]);
    return digits.join('');
}

export const getChangedOrderFields = (originalObj, editedObj) => {
    const changedFields = {};
    for (const key in editedObj) {
        if (key === 'address') {
            const addressObj = {}; 
            if (
                originalObj[key].village !== editedObj[key].village || 
                originalObj[key].street !== editedObj[key].street || 
                originalObj[key].apartmentNumber !== editedObj[key].apartmentNumber || 
                originalObj[key].additional !== editedObj[key].additional
            ) {
                
                addressObj.village = editedObj[key].village; 
                addressObj.street = editedObj[key].street; 
                addressObj.apartmentNumber = editedObj[key].apartmentNumber; 
                addressObj.additional = editedObj[key].additional;
            } 
            if (Object.keys(addressObj).length) {
                
                changedFields[key] = addressObj;
            }
        } else if (key === 'date') {
            
            const d1 = originalObj[key]; 
            const d2 = editedObj[key];
            const dateObj = {};
            if (Math.abs(d1.min - d2.min) > 1000 * 60) {
                dateObj.min = d2.min;
            }
            if (Math.abs(d1.max - d2.max) > 1000 * 60) {
                dateObj.max = d2.max;
            }
            dateObj.max = (dateObj.min && !dateObj.max) ? d1.min : dateObj.max;

            if (dateObj.min || dateObj.max) {
                if (!dateObj.min) {
                    dateObj.min = dateObj.max;
                } else if (!dateObj.max) {
                    dateObj.max = dateObj.min;
                } 
                changedFields[key] = dateObj;
            }
        } else if (key === 'completionDate') {
            
            const d1 = originalObj[key]; 
            const d2 = editedObj[key];
            if (Math.abs(d1 - d2) > 1000 * 60) {
                
                changedFields[key] = d2;
            }
        } else if (
            key === 'advertType' ||
            key === 'orderType' ||
            key === 'city' ||
            key === 'profileType'
        ) {
            
            if (editedObj[key] !== originalObj[key]._id) {
                
                changedFields[key] = editedObj[key];
            }
        } else if (key === 'worker') {
            
            const orderWorker = originalObj[key] ? originalObj[key]._id : null; 
            if (editedObj[key] !== orderWorker) {
                
                changedFields[key] = editedObj[key];
            }
        } else {
            
            if (editedObj[key] !== originalObj[key]) {
                
                changedFields[key] = editedObj[key];
            }
        }
    }

    return changedFields;
};

export function getAvailableOrderUsers(
    orderUsers,
    city,
    profileType,
    botTelegramId,
) {
    return orderUsers.filter(
        (user) =>
            user.city._id === city._id &&
            user.profiles.some((prof) => prof._id === profileType._id) &&
            user.telegramId !== botTelegramId &&
            !user.deleted &&
            user.isActive &&
            accessor.workOnOrders(user),
    );
}

export const generateOrderCopiedText = (data, showClientPhone) => {
    const localUTC = data.city.UTC;
    let orderText = `**Заявка** 🆔${numberToEmoji(data.id)}
-**Реклама**: ${data.advertType.name}
-**Источник**: ${data.sourceType}
-**Тип заказа**: ${data.orderType.name}
🗣 **Клиент**: ${data.clientName}
📌 **Комментарий**: ${data.orderComment}
📍 **Город**: ${data.city.name}
**Адрес**: ${formatAddress(data.address)}
✔️ **Дата**: ${getLocalUTCDate(localUTC, data.date.min)}
**Местное время**: ${String(getLocalUTCTime(data.city.UTC, data.date, true))}
📞 **Телефон клиента**: ${showClientPhone ? data.clientPhone : '*'.repeat(11)}
🔘 **Направление**: ${data.profileType.name}, ${data.isProfile ? 'профиль' : 'непрофиль'}
✅ **Статус**: ${data.orderStatus.name}`;
    if (data.worker) {
        orderText += `\n**Мастер**: ${data.worker.fullname}`;
    }
    if (data.orderStatus.name === orderStatuses.DONE) {
        orderText += `
**Общая**: ${data.totalAmount}
**ЗПЧ**: ${data.partsCost}
**Чистыми**: ${data.clearAmount}
**К сдаче**: ${data.handOver}
**Завершена** ${getLocalUTCDate(localUTC, data.date.min)}`;
    }
    orderText += `\n${data.workerComment ? `**Комментарий мастера**: ${data.workerComment}` : ''}`;

    return orderText;
};

export function generatePassword(
    length,
    numbers,
    symbols,
    uppercase,
    lowercase,
) {
    let charset = '';
    let password = '';

    // Добавление символов в зависимости от параметров
    if (numbers) charset += '0123456789';
    if (symbols) charset += '!@#$%^&*()-_+=';
    if (uppercase) charset += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (lowercase) charset += 'abcdefghijklmnopqrstuvwxyz';

    // Генерация пароля
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset[randomIndex];
    }

    return password;
}

export function flattenPermissions(obj, result = {}, path = [], level = 0) {
    Object.entries(obj).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const newPath = [...path, key];
            const newValue = {
                flag: value.flag,
                path: newPath,
                level,
            };

            // Добавляем массивы, если они существуют
            Object.entries(value).forEach(([subKey, subValue]) => {
                if (Array.isArray(subValue)) {
                    
                    newValue[subKey] = subValue;
                }
            });
            
            result[key] = newValue;

            // Рекурсивно обрабатываем вложенные объекты
            flattenPermissions(value, result, newPath, level + 1);
        }
    });

    return result;
}
export function mergePermissions(template, permissions) {
    // Рекурсивная функция для копирования свойств description и label из template в permissions
    function merge(templateNode, permissionsNode) {
        // Создаем новый объект, чтобы не мутировать исходные объекты
        let result = {};

        // Проходим по всем ключам в template
        for (let key in templateNode) {
            if (templateNode.hasOwnProperty(key)) {
                // Если ключ существует в permissions
                if (permissionsNode.hasOwnProperty(key)) {
                    // Если значение - объект, рекурсивно обрабатываем его
                    if (typeof templateNode[key] === 'object' && !Array.isArray(templateNode[key])) {
                        result[key] = merge(templateNode[key], permissionsNode[key]);
                    } else {
                         //Иначе просто копируем значения
                        result[key] = permissionsNode[key];
                    }
                } else {
                    // Если ключ отсутствует в permissions, используем значения из template
                    if (typeof templateNode[key] === 'object' && !Array.isArray(templateNode[key])) {
                        result[key] = merge(templateNode[key], {});
                    } else {
                        result[key] = templateNode[key];
                    }
                }
            }
        }

        if (permissionsNode.hasOwnProperty('flag')) {
            
        }
        // Добавляем значения flag из permissions, если они существуют
        if (permissionsNode.hasOwnProperty('flag')) {
            result['flag'] = permissionsNode['flag'];
        }

        // Добавляем значения label и description из template, если они существуют
        if (templateNode.hasOwnProperty('label')) {
            result['label'] = templateNode['label'];
        }

        if (templateNode.hasOwnProperty('description')) {
            result['description'] = templateNode['description'];
        }

        return result;
    }

    // Начинаем рекурсивное слияние с корневых узлов
    return merge(template, permissions);
}

export function createPermsObject(template, permissions) {
    function processObject(obj, result) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          if (key === key.toUpperCase()) { // Check if the key is in uppercase
            const { flag } = value;
            const permission = permissions[key] || {};
            const { flag: permFlag, level: _, path: _1, enums: _2, ...rest } = permission;
  
            acc[key] = {
              flag: permFlag !== undefined ? permFlag : flag,
              ...rest
            };
  
            // Recursively process nested objects
            acc[key] = {
              ...acc[key],
              ...processObject(value, acc[key])
            };
          } else {
            // Recursively process non-uppercase nested objects
            acc[key] = processObject(value, {});
          }
        }
        return acc;
      }, result);
    }
  
    return processObject(template, {});
}

export function deepEqual(obj1, obj2) {
    // Проверка на одинаковые типы данных
    if (typeof obj1 !== typeof obj2) {
      return false;
    }
  
    // Проверка на примитивные типы данных
    if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 === obj2;
    }
  
    // Проверка на одинаковое количество свойств
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    // Проверка на равенство значений по каждому ключу
    for (const key of keys1) {
      if (!deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    // Если все проверки пройдены, значит объекты равны
    return true;
}

export function getStorageData(enumList, itemName) {
    if (!enumList.length) {
        return 'null';
    }
    const savedValue = localStorage.getItem(itemName);
    const hasValue = enumList.find(e => e._id === savedValue);
    if (hasValue) {
        return savedValue;
    }
    const newValue = enumList[0]._id;
    localStorage.setItem(itemName, newValue);
    return newValue;
}
